import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import SelfieClick from "./SelfieClick";
import { ImageValidation } from "../Validation/ImageValidation";
import config from "../../utils/config";
import Rejectreason from "./Rejectreason";
import { useKycFaceVerifyMutation } from "../../redux/kycApi";
import { set } from "zod";
const { imageUrl } = config;

const Face = ({ kycTrack, refetch }) => {
  const [image, setImage] = useState("/assets/img/icon2.png");
  const [selfie, setSelfie] = useState(null);
  const [imageType, setImageType] = useState("upload");
  const [useruploadSelfieImage, setUseruploadSelfieImage] = useState(
    "/assets/img/icon2.png"
  );
  const [selfieError, setSelfieError] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [selfieStatus, setSelfieStatus] = useState("0");
  const [rejectionReason, setRejectionReason] = useState("");

  const [selfiopen, setselfiopen] = useState(false);
  const [selfiie, setselfiie] = useState("");
  const [selfibtn, setselfibtn] = useState(false);
  const [selfieImagesDisabled, setselfieImagesDisabled] = useState(false);
  const [identityPic1, setIdentityPic1] = useState("");
  const [clickedSelfie, setClickedSelfie] = useState("");
  const [kycFaceVerify] = useKycFaceVerifyMutation();

  useEffect(() => {
    const info = kycTrack?.progress?.face_verification;

    const makeFileFromUrl = async (url, filename) => {
      try {
        const res = await fetch(url);
        const blob = await res.blob();
        return new File([blob], filename, { type: blob.type });
      } catch (err) {
        console.error("Error creating file from API image:", err);
        return null;
      }
    };

    if (info) {
      setSelfieStatus(info.status || "pending");
      setRejectionReason(info?.data?.reason || "");

      if (info?.data?.image) {
        const url = `${imageUrl}${info.data.image}`;
        setImageType("upload");
        setImage(url); // 🔥 this alone is enough for <img />
        setUseruploadSelfieImage(url); // for user uploaded image preview

        // Convert API image → File (for submit)
        makeFileFromUrl(url, "face_image.png").then((file) => {
          if (file) {
            setSelfie(file); // backend ke liye rakho
          }
        });
      }
    }
  }, [kycTrack]);

  const status = kycTrack?.progress?.face_verification?.status;
  const isEditable = status === "pending" || status === "rejected";

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImageType("upload");
    if (file) {
      setSelfie(file);
      setUseruploadSelfieImage(URL.createObjectURL(file));
      setSelfieError(ImageValidation("Selfie", file));
    }
  };

  const handleSelfieChange = (img) => {
    setImageType("selfie");
    setSelfie(img);
    setUseruploadSelfieImage(img);
    setClickedSelfie(img);
    setselfiopen(false);
    setselfiie(img);
    setselfibtn(true);
  };

  const handleSelfiopen = () => {
    navigator.mediaDevices
      ?.getUserMedia({ video: { width: 300 } })
      .then(() => {
        setselfiopen(true);
        setselfibtn(true);
        setSelfieError("");
      })
      .catch(() => {
        setSelfieError("No camera detected");
      });
  };

  const submitSelfie = async (e) => {
    e.preventDefault();

    if (!selfie) {
      setSelfieError("This field is required");
      return;
    }

    const error = ImageValidation("Selfie", selfie);
    if (error) {
      setSelfieError(error);
      return;
    }

    setBtnDisable(true);
    setTimeout(() => setBtnDisable(false), 6000);

    try {
      let formData;

      if (imageType === "upload") {
        formData = new FormData();
        formData.append("face_image", selfie);
        formData.append("type", "upload");
      } else {
        formData = { face_image: selfie };
        formData.type = "camera";
      }
      const response = await kycFaceVerify(formData);
      if (response?.error) {
        const errMsg =
          response.error.data?.message ||
          response.error?.message ||
          "Verification failed";
        toast.error(errMsg);
      } else if (response?.data) {
        toast.success(response.data?.message || "Selfie uploaded successfully");
        refetch();
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setBtnDisable(false);
    }
  };

  return (
    <div className="face-outer">
      <div className="">
        {/* <div className="col-md-3 col-12"></div> */}
        <div className="">
          <div className="white_box">
            <h6 className="position-relative">Face Verification</h6>
            <div className="row">
              <div className="col-md-6 col-12">
                <b className="mt-0">Requirements</b>
                <ul className="dit_ul mb-4">
                  <li>
                    The photo/scan must be clear, in color and uncompressed.
                  </li>
                  <li>The photo/scan must not be edited or cropped.</li>
                  {/* <li>
                    The document must be valid for 3+ months from submission.
                  </li> */}
                  {/* <li>Your full name and DOB must match the document.</li> */}
                  <li>Min size 10 Kb / Max size 5 Mb.</li>
                </ul>
              </div>
              <div className="form-group col-md-6 col-12">
                {!selfiopen ? (
                  <div id="file-upload-form" className="uploader mt-3">
                    <input
                      type="file"
                      id="selfie"
                      name="selfie"
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={!isEditable}
                    />
                    <label htmlFor="selfie" id="file-drag">
                      <img
                        src={useruploadSelfieImage || image}
                        className="img-fluid22"
                        alt="Identity"
                      />
                      <div id="start">
                        <div>Upload Face Image</div>
                      </div>
                    </label>
                    <p className="mt-0">
                      *Only jpeg, jpg & png files supported <br />
                      *For changing image, click on image upload section again.
                    </p>
                  </div>
                ) : (
                  <SelfieClick
                    fun={handleSelfieChange}
                    selfie_status={selfieStatus}
                    selfiie={selfiie}
                  />
                )}

                {selfieError && (
                  <div className="text-danger">
                    <p>{selfieError}</p>
                  </div>
                )}

                {isEditable && !selfiopen && (
                  <button className="btn btn-success" onClick={handleSelfiopen}>
                    Selfie
                  </button>
                )}
              </div>
            </div>

            <Rejectreason
              reason={kycTrack?.progress?.face_verification?.data?.reason}
              status={status}
            />

            {isEditable && (
              <button
                className="btn btn_man w100px"
                onClick={submitSelfie}
                disabled={btnDisable}
              >
                {status === "pending"
                  ? btnDisable
                    ? "Submitting..."
                    : "Submit"
                  : "Re-submit"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Face;
